<template>
  <v-dialog
    v-model="dialog"
    max-width="70%"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title>
        Dicom infomation Tag
        <v-spacer></v-spacer>
        <v-row  style="width: 50%" class="pa-3">
          <v-col>
          <v-slider
            v-model="instanceNumber"
            class="align-center"
            :max="sliderMax"
            :min="sliderMin"
            hide-details
            @input="onSliderChange"
          >
            <template v-slot:append>
              <v-text-field
                v-model="instanceNumber"
                class="mt-0 pt-0"
                hide-details
                single-line
                type="number"
                style="width: 60px"
              ></v-text-field>
            </template>
          </v-slider>
          </v-col>
          <v-col>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            dense
            outlined
          >
          </v-text-field>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="searched"
        :search="search"
      ></v-data-table>
    </v-card>
    <!-- <v-card class="pa-5">
      <v-card-title>Dicom Tag</v-card-title>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th>
              <input
                class="instancenumber"
                type="range"
                step="1"
                :min="sliderMin"
                :max="sliderMax"
                value="0"
                @input="onSliderChange"
                title="Instance number"
              />
            </th>
              <th>
               <v-text-field
               label="search"
               outlined
               dense
               hide-details
               v-model="search"
               @input="searchOnTable"
               ></v-text-field>
               </th>
            </tr>
            <tr>
              <th class="text-left">Name</th>
              <th class="text-left">Value</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in searched" :key="index">
              <td>{{ item.name }}</td>
              <td>{{ item.value }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card> -->
  </v-dialog>
</template>

<script>
import { getTagFromKey } from 'dwv'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    metaData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        return val
      }
    }
  },
  created () {},
  data () {
    return {
      // value: 0,
      search: null,
      searched: [],
      sliderMin: undefined,
      sliderMax: undefined,
      instanceNumber: 0,
      instanceNumbers: [],
      headers: [
        {
          text: 'name',
          align: 'start',
          sortable: false,
          value: 'name',
          width: '30%'
        },
        // { text: 'name', value: 'name' },
        { text: 'value', value: 'value' }
      ]
    }
  },
  watch: {
    value () {
      this.init()
    }
  },
  methods: {
    init () {
      const instanceElement = this.metaData['00200013']
      if (typeof instanceElement !== 'undefined') {
        let instanceNumberValue = instanceElement.value
        if (typeof instanceNumberValue === 'string') {
          instanceNumberValue = [instanceNumberValue]
        }
        // convert string to numbers
        this.instanceNumbers = instanceNumberValue.map(Number)
        this.instanceNumbers.sort((a, b) => a - b)

        this.sliderMin = 0
        this.sliderMax = this.instanceNumbers.length - 1
        this.instanceNumber = this.instanceNumbers[this.sliderMin]
      }

      const metaArray = this.getMetaArray(this.metaData, this.instanceNumber)
      this.searched = metaArray
    },
    onSliderChange (event) {
      this.instanceNumber = this.instanceNumbers[event]
      this.searchOnTable()
    },
    searchOnTable () {
      const metaArray = this.getMetaArray(this.metaData, this.instanceNumber)
      this.searched = this.searchAll(metaArray, this.search)
    },

    getMetaArray (tagData, instanceNumber) {
      let reducer
      if (this.isDicomMeta(tagData)) {
        reducer = this.getDicomTagReducer(tagData, instanceNumber, '')
      } else {
        reducer = this.getTagReducer(tagData)
      }
      const keys = Object.keys(tagData)
      return keys.reduce(reducer, [])
    },
    isDicomMeta (meta) {
      return typeof meta['00020010'] !== 'undefined'
    },
    getTagReducer (tagData) {
      return function (accumulator, currentValue) {
        accumulator.push({
          name: currentValue,
          value: tagData[currentValue].value
        })
        return accumulator
      }
    },
    searchAll (items, term) {
      if (term) {
        return items.filter((item) => {
          return (
            this.toLower(item.name).includes(this.toLower(term)) ||
            this.toLower(item.value).includes(this.toLower(term))
          )
        })
      }
      return items
    },

    toLower (text) {
      if (text) {
        return text.toString().toLowerCase()
      } else {
        return ''
      }
    },

    getDicomTagReducer (tagData, instanceNumber, prefix) {
      return (accumulator, currentValue) => {
        const tag = getTagFromKey(currentValue)
        let key = tag.getNameFromDictionary()
        if (typeof key === 'undefined') {
          // add 'x' to help sorting
          key = 'x' + tag.getKey()
        }
        const name = key
        const element = tagData[currentValue]
        let value = element.value
        // possible 'merged' object
        // (use slice method as test for array and typed array)
        if (
          typeof value.slice === 'undefined' &&
          typeof value[instanceNumber] !== 'undefined'
        ) {
          value = value[instanceNumber]
        }
        // force instance number (otherwise takes value in non indexed array)
        if (name === 'InstanceNumber') {
          value = instanceNumber
        }
        // recurse for sequence
        if (element.vr === 'SQ') {
          // sequence tag
          accumulator.push({
            name: (prefix ? prefix + ' ' : '') + name,
            value: ''
          })
          // sequence value
          for (let i = 0; i < value.length; ++i) {
            const sqItems = value[i]
            const keys = Object.keys(sqItems)
            const res = keys.reduce(
              this.getDicomTagReducer(
                sqItems,
                instanceNumber,
                prefix + '[' + i + ']'
              ),
              []
            )
            accumulator = accumulator.concat(res)
          }
        } else {
          // shorten long 'o'ther data
          if (element.vr[0] === 'O' && value.length > 10) {
            value =
              value.slice(0, 10).toString() + '... (len:' + value.length + ')'
          }
          accumulator.push({
            name: (prefix ? prefix + ' ' : '') + name,
            value: value.toString()
          })
        }
        return accumulator
      }
    }
  }
}
</script>

<style>
.instancenumber{
  width: 100%;
  color: blue;
}
</style>
